@if (viewModel$ | async; as vm) {

    <mat-grid-list cols="6" class="gallery-wrap" gutterSize="12px">

        @for (item of vm.imageSlots;track item; let index = $index) {

            <mat-grid-tile [colspan]="index === 0 || index === 7 ? 2 : 1"
                           [rowspan]="index === 0 || index === 7 ? 2 : 1"
                           class="gallery-item">

                <img [src]="item.next" class="gallery-content" alt="" [class.hidden]="vm.currentIndex !== index">
                <img [src]="item.current" class="gallery-content" alt="" [class.hidden]="vm.currentIndex === index">

            </mat-grid-tile>

        }

    </mat-grid-list>

}